<button
  [matButton]="buttonStyle()"
  (click)="clicked.emit($event)"
  [class.button-big]="big()"
  [class.button-small]="small()"
  [class.loading]="loading()"
  [matTooltipPosition]="tooltipPosition()"
  [matTooltip]="tooltip()"
  [class]="buttonStyle()"
  [disabled]="disabled()"
  [type]="type()"
  [matBadge]="badge() || ''"
  [name]="name()"
>
  <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>

</button>

<ng-template #contentTemplate>
  @if (icon(); as icon) {
    <ui-icon class="icon" [faName]="icon" [faStyle]="iconStyle()"></ui-icon>
  }
  <ng-content></ng-content>

  @if (loading()) {
    <ui-icon class="spinner" [faName]="'spinner-third'" [faStyle]="'light'" animation="spin"></ui-icon>
  }
</ng-template>
